<template>
  <LoadingContainer
    :is-loaded="isLoaded"
    :total="subjectsLength"
    kind="Subjects"
    size="2rem"
  >
     <fieldset class="subject-picker" slot="default">
      <legend class="subject-picker__legend form__label">Subject</legend>

      <template v-for="s in subjects">
        <input
          type="radio"
          :key="`input-${s.id}`"
          :id="s.id"
          :value="s.id"
          name="subject-picker"
          class="subject-picker__input"
          v-model="checkedSubject"
          @change="$emit('input', [checkedSubject])"
        />

        <label
          :key="`label-${s.id}`"
          :for="s.id"
          class="subject-picker__label"
          :style="`--color:${s.color}`"
        >
          {{ s.name }}
        </label>
      </template>
    </fieldset>

    <router-link
      slot="button"
      class="button button--border button--small"
      :to="{
        name: 'settings-subjects',
        query: {
          add: true
        }
      }"
      replace
    >
      Add Subject
    </router-link>
  </LoadingContainer>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'SubjectPicker',

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      checkedSubject: ''
    }
  },

  computed: {
    ...mapGetters({
      subjects: 'subjects/sortedSubjects',
      subjectsLength: 'subjects/subjectsLength',
      isLoaded: 'subjects/isLoaded'
    })
  },

  mounted () {
    this.checkedSubject = this.value[0]

    store.dispatch('subjects/getSubjects')
  }
}
</script>

<style lang="scss">
.subject-picker {
  margin: 1rem 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  border: 0;
}

.subject-picker__legend {
  display: flex;
  flex: 1 0 100%;
}

.subject-picker__input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.subject-picker__label {
  margin: 0 0.125rem 0.125rem 0;
  padding: .125rem 1rem;
  width: auto;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  border-radius: 2rem;
  font-size: .8rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: (1rem / 32);
  color: var(--color-page-fg);
  background-color: var(--color, #CFD8DC);
  border: .125rem solid #FFF;

  &:hover,
  &:active {
    border-color: #78909C;
  }

  :focus + & {
    outline: none;
    box-shadow:
      0 0 0 .125rem var(--color-page-bg),
      0 0 0 .25rem #78909C;
  }

  :checked + & {
    border-color: currentColor;
  }
}
</style>
